import { useState } from "react";
import { api, resolveImage } from "@/lib/api";
import { Upload } from "lucide-react";
import { toast } from "sonner";

/**
 * Reusable image picker that uploads to /api/admin/upload/image
 * and returns the resulting public URL via onChange.
 */
export default function ImageUploader({ value, onChange, dataTestid = "image-uploader" }) {
    const [busy, setBusy] = useState(false);

    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const r = await api.post("/admin/upload/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
            onChange?.(r.data.url);
            toast.success("Bild hochgeladen");
        } catch (err) {
            toast.error("Upload fehlgeschlagen");
        } finally {
            setBusy(false);
            e.target.value = "";
        }
    };

    return (
        <div className="flex items-start gap-4" data-testid={dataTestid}>
            <div className="h-20 w-20 rounded-xl bg-brand-cream-dark border border-black/5 overflow-hidden flex items-center justify-center">
                {value ? <img src={resolveImage(value)} alt="" className="h-full w-full object-cover" /> : <Upload className="h-5 w-5 text-brand-charcoal/40" />}
            </div>
            <div className="flex-1">
                <input
                    type="text"
                    value={value || ""}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder="Bild-URL oder unten hochladen"
                    className="input-clean text-sm"
                />
                <label className="mt-2 inline-flex items-center gap-2 cursor-pointer text-xs font-semibold text-brand-green hover:text-brand-charcoal">
                    <Upload className="h-3.5 w-3.5" /> {busy ? "Hochladen..." : "Datei hochladen"}
                    <input type="file" className="hidden" accept="image/*" onChange={upload} disabled={busy} />
                </label>
            </div>
        </div>
    );
}
